export const FEATURE_FLAGS = [
  'cx_cancer_payor_issues_enabled',
  'cx_custom_rna_hcx',
  'cx_pediatric_cma_in_sf',
  'cx_ordering_carrier_nips_exception',
  'cx_is_stargate_cart_svc_proxy_enabled', // https://invitae.jira.com/browse/CELT-1918
  'cx_order_again_improvements_enabled', // https://invitae.jira.com/browse/CELT-1922
  'cx_custom_test_menu_launchpad', // https://invitae.jira.com/browse/CELT-2037
  'cx_org_context_bar_launchpad', // https://invitae.jira.com/browse/CELT-2039
  'cx_remove_core_panel_from_order_again_section', // https://invitae.jira.com/browse/CELT-2167
  'cx_genetic_risk_assessment',
]

// convert FEATURE_FLAGS into string literal union type
export type FeatureFlag = (typeof FEATURE_FLAGS)[number]
